import moment from 'moment'

const Helpers = {
  // Lista os PDFs do receituário digital (Mevo) a partir de Documentos[].
  // onlyStored: considera só os documentos já copiados para o nosso storage (atendimentos finalizados),
  // pois as URLs originais da Mevo expiram em 24h.
  getPrescriptionDocuments(value, onlyStored = false) {
    const types = {
      RECEITA: { label: 'Receita', icon: 'fa-pills' },
      EXAME: { label: 'Pedido de exame', icon: 'fa-stethoscope' },
      ATESTADO: { label: 'Atestado', icon: 'fa-notes-medical' },
      ENCAMINHAMENTO: { label: 'Encaminhamento', icon: 'fa-share-square' },
      RELATORIO: { label: 'Relatório', icon: 'fa-file-medical-alt' },
    };
    if (value == null || !Array.isArray(value.Documentos)) {
      return [];
    }
    const documents = value.Documentos.filter(document => document.URL && (!onlyStored || document.Armazenado));
    const totals = {};
    documents.forEach(document => totals[document.TipoDocumento] = (totals[document.TipoDocumento] || 0) + 1);
    const counters = {};
    return documents.map((document, index) => {
      const type = types[document.TipoDocumento] || { label: 'Documento', icon: 'fa-file-pdf' };
      counters[document.TipoDocumento] = (counters[document.TipoDocumento] || 0) + 1;
      return {
        key: index,
        url: document.URL,
        icon: type.icon,
        label: totals[document.TipoDocumento] > 1 ? type.label + ' ' + counters[document.TipoDocumento] : type.label,
      };
    });
  },
  getOwnerId() {
    let user = JSON.parse(localStorage.getItem('user'));
    if(!user) {
        return null;
    }

    return user.person.client.person_id
  },
  isOwner() {
    let user = JSON.parse(localStorage.getItem('user'));
    if(user == null || user.person == null || user.person.client == null) {
      return false;
    }

    return user.person.client.person_id == user.person.id;
  },
  checkOwner(personId) {
    let user = JSON.parse(localStorage.getItem('user'));
    if(user == null || user.person == null || user.person.client == null) {
      return false;
    }

    return user.person.client.person_id == personId;
  },
  checkPermission(module, permission, overwriteOwner = false) {
    if(!this.isOwner() || overwriteOwner) {
      let user = JSON.parse(localStorage.getItem('user'));
      if(user == null || user.person == null || user.person.permissions == null) {
        return false;
      }

      if (typeof user.person.permissions != 'undefined') {
        let pFounded = user.person.permissions.find(p => {
          return p.module == module;
        });

        if (pFounded != null && pFounded[permission]) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    } else {
      return true;
    }
  },
  planHasPermission(module) {
    let user = JSON.parse(localStorage.getItem('user'));
    if(user == null || user.person == null || user.person.client == null) {
      return false;
    }
    let client = user.person.client,
      subscription = client.subscription;

    let planPermission = this.planPermissions().find(p => {
      return p.module == module;
    });

    if (subscription != null && subscription.status == 'ACTIVE') {
      return planPermission.plans.indexOf(subscription.plan) >= 0;
    }

    let testUntil = moment(client.created_at).add(7, 'days').endOf('day'),
        daysToEndTrial = testUntil.diff(moment().endOf('day'), 'days', true);
    if(daysToEndTrial >= 0) {
      return true;
    }
    if(client.mandic_campaign && client.mandic_campaign.valid === 1) {
      return planPermission.plans.indexOf(client.mandic_campaign.default_plan) >= 0;
    }
    return false;
  },
  plansWithFullAdministration() {
    return [1, 2];
  },
  plansWithTelehealth() {
    return [2];
  },
  subscriptionHasFullAdministration() {
    let user = JSON.parse(localStorage.getItem('user'));
    return this.plansWithFullAdministration().indexOf(user.person.client.subscription.plan) >= 0;
  },
  subscriptionHasTelehealth() {
    let user = JSON.parse(localStorage.getItem('user'));
    return this.plansWithTelehealth().indexOf(user.person.client.subscription.plan) >= 0;
  },
  uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  },
  planPermissions() {
    return [
      { module: 'financial', plans: [1, 2] },
      { module: 'telehealth', plans: [2] },
    ]
  },
  getModules() {
    return [
      { module: 'agendas', can_see: true, can_add: true, can_edit: true, can_remove:true, can_manage: true },
      { module: 'patients', can_see: true, can_add: true, can_edit: true, can_remove:true, can_manage: true },
      { module: 'professionals', can_see: true, can_add: true, can_edit: true, can_remove:true, can_manage: true },
      { module: 'secretaries', can_see: true, can_add: true, can_edit: true, can_remove:true, can_manage: true },
      { module: 'coordinators', can_see: true, can_add: true, can_edit: true, can_remove:true, can_manage: true },
      { module: 'permissions', can_see: true, can_add: true, can_edit: true, can_remove:true, can_manage: true },
      { module: 'forms', can_see: true, can_add: true, can_edit: true, can_remove:true, can_manage: true },
      { module: 'dashboard', can_see: true, can_add: true, can_edit: true, can_remove:true, can_manage: true },
      { module: 'client-data', can_see: true, can_add: true, can_edit: true, can_remove:true, can_manage: true },
      { module: 'directing-sectors', can_see: true, can_add: true, can_edit: true, can_remove:true, can_manage: true },
      { module: 'subscription', can_see: true, can_add: true, can_edit: true, can_remove:true, can_manage: true },
      { module: 'attendance-guides', can_see: true, can_add: true, can_edit: true, can_remove:true, can_manage: true },
      { module: 'incomes', can_see: true, can_add: true, can_edit: true, can_remove:true, can_manage: true },
      { module: 'expenses', can_see: true, can_add: true, can_edit: true, can_remove:true, can_manage: true },
      { module: 'cash-flow', can_see: true, can_add: true, can_edit: true, can_remove:true, can_manage: true },
    ]
  },
  getModuleName(module) {
    let moduleName = '';
    switch (module) {
      case 'agendas':
        moduleName = 'Agendas';
        break;
      case 'patients':
        moduleName = 'Pacientes';
        break;
      case 'professionals':
        moduleName = 'Profissionais';
        break;
      case 'secretaries':
        moduleName = 'Secretárias';
        break;
      case 'coordinators':
        moduleName = 'Coordenadores';
        break;
      case 'permissions':
        moduleName = 'Permissões';
        break;
      case 'forms':
        moduleName = 'Prontuários';
        break;
      case 'dashboard':
        moduleName = 'Dashboard';
        break;
      case 'subscription':
        moduleName = 'Minha Assinatura';
        break;
      case 'client-data':
        moduleName = 'Configurações Gerais';
        break;
      case 'directing-sectors':
        moduleName = 'Setores';
        break;
      case 'attendance-guides':
        moduleName = 'Guias de Atendimento';
        break;
      case 'incomes':
        moduleName = 'Contas a Receber';
        break;
      case 'expenses':
        moduleName = 'Contas a Pagar';
        break;
      case 'cash-flow':
        moduleName = 'Fluxo de Caixa';
        break;
    }
    return moduleName;
  },
  getStatusName(status) {
    switch (status) {
      case 'SCHEDULED':
        status = 'Agendado';
        break;
      case 'CONFIRMED':
        status = 'Confirmado';
        break;
      case 'CANCELED':
        status = 'Cancelado';
        break;
      case 'MISSED':
        status = 'Faltou';
        break;
      case 'SHOWEDUP':
        status = 'Compareceu';
        break;
      case 'ATTENDED':
        status = 'Atendido';
        break;
      case 'FINISHED':
        status = 'Finalizado';
        break;
      default:
        status = (status.indexOf('RESCHEDULED') > -1)?'Reagendado':'Não identificado';
        break;
    }
    return status;
  },
  clone(obj) {
    if (null == obj || "object" != typeof obj) return obj;
    var copy = obj.constructor();
    for (var attr in obj) {
      if (obj.hasOwnProperty(attr)) copy[attr] = obj[attr];
    }
    return copy;
  }
};

export default Helpers
